import React from 'react';
import { ISchemaLevelObjectType } from 'utils/types';

interface SnowflakeIconProps {
  objectType: 'database' | 'schema' | 'column' | ISchemaLevelObjectType;
  highlighted?: boolean;
}

export default function SnowflakeIcon(props: SnowflakeIconProps): JSX.Element {
  // Function to get the appropriate icon based on object type
  const getIconSrc = (): string => {
    switch (props.objectType) {
      case 'database':
        return props.highlighted === true ? '/static/database-icon-solid.svg' : '/static/database-icon.svg';
      case 'schema':
        return props.highlighted === true ? '/static/schema-icon-solid.svg' : '/static/schema-icon.svg';
      case 'table':
        return props.highlighted === true ? '/static/table-icon-solid.svg' : '/static/table-icon.svg';
      case 'view':
        return '/static/view-icon.svg';
      case 'column':
        return '/static/column-icon.svg';
      case 'function':
        return '/static/function-icon.svg';
      case 'procedure':
        return '/static/procedure-icon.svg';
      case 'file_format':
        return '/static/file-format-icon.svg';
      case 'sequence':
        return '/static/sequence-icon.svg';
      case 'pipe':
        return '/static/pipe-icon.svg';
      default:
        return '/static/table-icon.svg';
    }
  };

  const icon = getIconSrc();

  return <img className="w-5 h-5" src={icon} alt={props.objectType} />;
}
